import sendAnalyticsEvent from './sendAnalyticsEvent';
import MHelper from "./MHelper";
import setCookie from './setCookie';
import delayedEvents from './delayedEvents';

const cookieLifetime = 0.013889; // время жизни куки в днях

export default function interstitialObserver() {
  window.hashtag_watcher = window.hash_tag_watcher || setInterval(() => {
    if(window.location.hash.includes('google_vignette')){
      clearInterval(window.hashtag_watcher);
      window.hashtag_watcher = null;
      sendAnalyticsEvent('INTERSTITIAL_AD_SHOW');
      //setCookie('shownInterstitial', '1', cookieLifetime);
    }
    if(window.location.hash.includes('goog_game_inter')){
      clearInterval(window.hashtag_watcher);
      window.hashtag_watcher = null;
      sendAnalyticsEvent('DOUBLE_LOADED');
//      setCookie('shownInterstitial', '1', cookieLifetime);
    }
  }, 300);
}
